export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/agent/tp',
		name: 'NbuAgentTp',
		title: {
			single: 'NbuAgentTp',
			plural: 'NbuAgentTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "A",
				"code": null,
				"name": "Страховий агент",
				"caption": "Страховий агент",
				"isBlocked": false
			},
			{
				"id": "S",
				"code": null,
				"name": "Субагент",
				"caption": "Субагент",
				"isBlocked": false
			},
			{
				"id": "D",
				"code": null,
				"name": "Додатковий страховий агент",
				"caption": "Додатковий страховий агент",
				"isBlocked": false
			}
		],
	},
}
